export const SCHEDULE = 'schedule';

export const PERIOD = 'period';
export const START_TIME = 'startTime';
export const DAYS = 'repeatDays';

export const ON_DATE = 'runOnceDate';

export const ONCE = 1;
export const DAY = 2;
export const WEEK = 3;
export const MONTH = 4;

export const DAYS_LIST = [
  {
    id: 'Sun',
    name: 'Sun',
  },
  {
    id: 'Mon',
    name: 'Mon',
  },
  {
    id: 'Tue',
    name: 'Tue',
  },
  {
    id: 'Wed',
    name: 'Wed',
  },
  {
    id: 'Thu',
    name: 'Thu',
  },
  {
    id: 'Fri',
    name: 'Fri',
  },
  {
    id: 'Sat',
    name: 'Sat',
  },
];

export const numberWithZero = (i) => {
  return `${i.toString().padStart(2, '0')}`;
};

export const HOURS_LIST = new Array(24).fill(1).map((_v, i) => {
  return { id: i, name: numberWithZero(i) };
});

export const MINUTES_LIST = new Array(4).fill(1).map((_v, i) => {
  let minute = i * 15;
  return { id: minute, name: numberWithZero(minute) };
});

export const TIME_LIST = HOURS_LIST.map((hour) =>
  MINUTES_LIST.map((minutes) => ({
    name: `${hour.name}:${minutes.name}`,
    id: `${hour.id}:${minutes.id}`,
  }))
).flat();
